import { useEffect, useState } from "react";

import { reportsApi } from "../services/reports.api";

export interface ReportCategoryOption {
  id: string;
  /** Girintili etiket: üst kategoriler düz, alt kategoriler "↳" ile. */
  name: string;
}

/**
 * Rapor filtrelerinde kullanılan eğitim kategorisi listesi.
 *
 * Ağaç, dropdown'da hiyerarşi görünsün diye girintilenerek düzleştirilir:
 * üst kategori düz yazılır, her alt seviye iki kırılmaz boşluk + "↳" alır.
 * Aynı kalıp eğitim oluşturma ekranındaki kategori dropdown'ında da kullanılıyor
 * (`CreateEducationPage`), iki ekran arasında görünüm tutarlı kalsın diye
 * bilerek birebir aynı biçim seçildi.
 *
 * Alt kategorileri ayrıca seçmeye gerek yok: backend, seçilen kategorinin tüm
 * alt dalını otomatik kapsama alıyor.
 */
export function useReportCategories(): ReportCategoryOption[] {
  const [categories, setCategories] = useState<ReportCategoryOption[]>([]);

  useEffect(() => {
    let cancelled = false;
    reportsApi
      .getCategoryTree()
      .then((tree) => {
        if (cancelled) return;
        const flat: ReportCategoryOption[] = [];
        const walk = (nodes: typeof tree, depth: number) => {
          for (const node of nodes) {
            const name = node.name ?? node.label ?? node.id;
            // Girinti kırılmaz boşlukla yapılır: normal boşluk HTML'de
            // daraltıldığı için seviye farkı kaybolurdu.
            const prefix = depth === 0 ? "" : `${"  ".repeat(depth)}↳ `;
            flat.push({ id: node.id, name: `${prefix}${name}` });
            const kids = node.children ?? node.subCategories;
            if (kids?.length) walk(kids, depth + 1);
          }
        };
        walk(tree, 0);
        setCategories(flat);
      })
      .catch(() => {
        if (!cancelled) setCategories([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return categories;
}
